module.exports = __webpack_public_path__ + "img/logo-dark.2cbdb368.png";